module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "pl-7"
    }
  }), _vm._v("THE BASICS OF WOOL APPLIQUÉ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wool appliqué is the process of cutting out wool shapes and sewing them onto a large piece of fabric. The technique can result in beautiful designs.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tools and Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Tools")]), _vm._v(" "), _c('p', {
    staticClass: "figa"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fusible web, freezer paper (Quilter’s Freezer Paper Sheets by C&T Publishing), quilting paper, scissors, marker, mechanical fabric pencil, appliqué pins, and chenille needles")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Quilting paper")]), _vm._v(" is used to trace the design layout for accurate placement. You can also use lightweight stabilizer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "smm"
  }, [_vm._v("good pair of fabric scissors")]), _vm._v(" are required to cut the wool. I prefer a 6˝ scissor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "smm"
  }, [_vm._v("permanent marker")]), _vm._v(" is used to trace the placement of the design onto the quilting paper or lightweight stabilizer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "smm"
  }, [_vm._v("mechanical fabric pencil")]), _vm._v(" is used to draw any embroidery guidelines such as stems on the fabric. I use a white lead and a green lead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Appliqué pins")]), _vm._v(" are short pins used to pin the wool appliqué shapes onto the background. Because they are short, your thread is less likely to get caught on them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Chenille needles")]), _vm._v(" have a sharp point and a large eye to accommodate the thickness of the perle cotton being used for embroidery. I use a size 24 needle for size 8 and 12 perle cotton and a size 22 needle for size 5 perle cotton. If it is difficult to pull the stitch through the wool, it may be that the needle is too small and not creating a big enough hole in the background wool for the thread to pass through.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "pl-8"
    }
  }), _c('b', [_c('i', [_vm._v("Freezer Paper and Fusible Web: What Is the Difference?")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can use both freezer paper and fusible web to trace the appliqué pattern shapes. Using freezer paper or fusible web results in accurately cutout appliqué shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Freezer paper")]), _vm._v(" is a sheet of paper with a wax coating on one side that temporarily sticks to wool when heat is applied. The appliqué pattern shapes are traced onto the freezer paper and then pressed onto the wool. The shapes are then cut out, the freezer paper is removed, and the cutout shapes are placed on a background fabric. Pins are needed to hold the shapes in place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Fusible web")]), _vm._v(" is a sheet of paper coated with glue that becomes sticky when heat is applied. It is used for designer patterns, which are drawn in reverse. If a designer pattern is drawn in reverse, the appliqué shapes are traced onto the fusible web and fused onto wool using an iron. The shapes are then cut out and the paper is removed, leaving the fusible web (glue) on the wool. The shapes are placed on a background fabric and fused in place using an iron. Pins and basting are not required when using fusible web.")]), _vm._v(" "), _c('div', {
    staticClass: "parad"
  }, [_c('p', {
    staticClass: "indentd"
  }, [_c('b', [_vm._v("NOTE: Which to Use?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wrote the project instructions for use with freezer paper. If you would prefer to use fusible web, see "), _c('a', {
    attrs: {
      "href": "#/xhtml/0005_chaptertitle2#pl-10"
    }
  }, [_vm._v("Another Option: Using Fusible Web")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Thread")]), _vm._v(" "), _c('p', {
    staticClass: "figa"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wool thread, perle cotton, and embroidery floss")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Wool thread")]), _vm._v(" (or a wool and acrylic blend) is typically used to whipstitch the appliqué shapes to the background.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Embroidery floss")]), _vm._v(" can be used for whipstitching. Use 1 strand in a color that matches the color of the appliqué shape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_vm._v("Perle cotton thread")]), _vm._v(" is probably the most desirable thread to use for decorative embroidery. It comes in various sizes—the higher the number, the thinner the perle cotton. Some companies spell "), _c('i', [_vm._v("perle cotton")]), _vm._v(" as "), _c('i', [_vm._v("pearl cotton")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "pl-9"
    }
  }), _c('b', [_vm._v("Getting Started")])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "apps1"
    }
  }, [_vm._v("Cut Out the Appliqué Shapes")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Place a sheet of freezer paper, shiny side down, over the pattern drawing. Trace the pattern shapes, indicating the color to be used.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Cut out the freezer-paper shapes about ⅛˝ outside the traced line.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Place the freezer-paper shapes on the corresponding color wool. Use a warm iron to press the freezer paper onto the wool. The freezer paper will stick to the wool.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Cut out the shapes on the traced lines.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Peel off the freezer paper.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('a', {
    attrs: {
      "id": "pl-10"
    }
  }), _c('b', [_vm._v("Another Option: Using Fusible Web")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For this technique, we’ll use a sheet of fusible web and freezer paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "wh"
  }, [_vm._v("1.")]), _vm._v(" Iron a piece of fusible web to the back side of a piece of wool from which the appliqué shape will be cut. Do not peel the paper off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "wh"
  }, [_vm._v("2.")]), _vm._v(" Continue using the fusible web, but follow Cut Out the Appliqué Shapes, "), _c('a', {
    attrs: {
      "href": "#/xhtml/#pl-9"
    }
  }, [_vm._v("Steps 1–5")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "wh"
  }, [_vm._v("3.")]), _vm._v(" Peel off the paper backing from the fusible web, place the shapes onto the background, and fuse in place following the manufacturer’s directions.")]), _vm._v(" "), _c('div', {
    staticClass: "parad1a"
  }, [_c('p', {
    staticClass: "indentd"
  }, [_c('b', [_vm._v("NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For some designer patterns, accurate placement of the shapes may not be critical. For these designs, shapes can be placed by referring to the pattern photo or drawing. Other designer patterns require accurate placement.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "plte1"
    }
  }, [_vm._v("Create a Placement Template")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This technique uses quilting paper to create a template.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut a piece of quilting paper the same size as the background wool or as directed in the project directions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" If the placement and embroidery guide has dashed lines to aid in placement, find the horizontal and vertical centerlines on the quilting paper. Using a straightedge and marker, draw a dashed line for each.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Lay the quilting paper on top of the placement and embroidery guide, lining up the dashed lines of the quilting paper and the pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "figa",
    attrs: {
      "id": "patt2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Placement and embroidery guide")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Use a marker to trace the shapes and any stems of the design onto the quilting paper. It is not necessary to trace the stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "pl-11"
    }
  }), _vm._v("Placing Shapes on the Background Fabric")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Place the template on the background fabric.")]), _vm._v(" "), _c('div', {
    staticClass: "parad1"
  }, [_c('p', {
    staticClass: "indentd1"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/tt.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('i', [_vm._v("For larger projects, pin the top edge of the quilting paper to the top edge of the background wool, creating a hinge.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Sew the appliqué shapes in place as shown, starting from the first layer placed on the background fabric. Position the first layer of appliqué shapes under the placement template. In this case, the first layer is the hill, leaves, and daffodil petals. Stitch them in place, referring to "), _c('a', {
    attrs: {
      "href": "#/xhtml/0005_chaptertitle2#pl-12"
    }
  }, [_vm._v("Sewing the Appliqué Shapes to the Background")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First layer of appliqué shapes positioned under the placement template")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First layer of appliqué shapes whipstitched to the background fabric")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second layer of appliqué shapes positioned under the placement template")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second layer of appliqué shapes pinned to the background fabric")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Continue positioning and whipstitching until all the layers are added.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "pl-12"
    }
  }), _vm._v("Sewing the Appliqué Shapes to the Background")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wrote the project instructions for use with the whipstitch. If you would prefer to use the blanket stitch, see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#pl-13"
    }
  }, [_vm._v("Another Option: Blanket Stitch")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Whipstitch")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whipstitch is a small stitch that is sewn perpendicular to the cut edge of the appliqué shape. Use a thread that matches the color of the wool shape and that isn’t too noticeable. This method is commonly used when the appliqué shape is embellished with embroidery after the shape is sewn to the background wool. Using a whipstitch enables the embroidery work to be the focal point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Knot the thread. Come up through the appliqué shape from the back of the piece.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smm"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Insert the needle into the background wool, angle the needle, and come up in the appliqué shape. Pull the thread through, creating a stitch that is perpendicular to the cut edge of the appliqué shape.")]), _vm._v(" "), _c('p', {
    staticClass: "figa"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Stitches are a scant ⅛˝ apart and a scant ⅛˝ long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stitches will appear on a slant on the back side of the background wool.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('a', {
    attrs: {
      "id": "pl-13"
    }
  }), _c('b', [_vm._v("Another Option: Blanket Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The blanket stitch is typically a bigger stitch and may be intentionally visible by using a color of thread contrasting from the appliqué shape. It is sometimes described as having a “primitive” look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You may prefer to use the blanket stitch instead of the whipstitch for the projects in this book. In these projects, however, the decorative embroidery is the focus. With that in mind, use a thread "), _c('i', [_vm._v("matching")]), _vm._v(" the color of the appliqué wool so that the blanket stitch does not detract from the decorative embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "wh"
  }, [_vm._v("1.")]), _vm._v(" Knot the thread. Come up through the background wool just at the edge of the appliqué shape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "wh"
  }, [_vm._v("2.")]), _vm._v(" With the needle pointing away from the appliqué shape, insert the needle into the appliqué shape, and come up through the background wool just at the edge of the appliqué shape. The working thread goes under the needle.")]), _vm._v(" "), _c('p', {
    staticClass: "figa"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Stitches should be about ⅛˝ long and ⅛˝ apart.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Adding Decorative Embroidery")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Refer to "), _c('a', {
    attrs: {
      "href": "#/xhtml/0012_chaptertitle9"
    }
  }, [_vm._v("Embroidery Stitches")]), _vm._v(" for guidance on the stitches used to embellish the projects in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Embroidery stitches typically have no functional purpose, so they usually do not need to go through the background fabric. For the projects in this book, I wrote the embroidery directions for use with perle cotton. Instead of perle cotton, you may use two or three strands of embroidery floss.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-049deb44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0005_chapter-title-2.vue
// module id = 69
// module chunks = 0